<template>
  <div>
    <div>
      <aha-modal
        @hide="$emit('hide')"
        :title="title"
        action-position="justify-center"
      >
        <div>
          {{ $i18nPresenter.t('If the problem still occurs, please check your internet connection or contact us at') }}
          <a href="mailto:hi@ahaslides.com">hi@ahaslides.com</a>
          {{ $i18nPresenter.t('for support.') }}
        </div>

        <template #action>
          <aha-antd-button
            v-aha-emit-action
            :name="`error-${title}`"
            @click="$emit('hide')"
          >
            {{ $i18nPresenter.t('OK') }}
          </aha-antd-button>
        </template>
      </aha-modal>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>
